module.exports = __webpack_public_path__ + "static/media/geoLocation.5ca60dcd.svg";